import { Drawer, drawerClasses } from "@mui/material";

import { NavigationSidebarSxProps, NavigationSlotsProps } from "../types";
import { NavigationContent } from "./NavigationContent";

type NavigationMobileDrawerProps = NavigationSidebarSxProps &
  NavigationSlotsProps & {
    isOpen: boolean;
    onClose: () => void;
  };

export const NavigationMobileDrawer = ({
  isOpen,
  onClose,
  slots,
  sxSidebar,
}: NavigationMobileDrawerProps) => {
  return (
    <Drawer
      onClose={onClose}
      open={isOpen}
      sx={{
        [`& .${drawerClasses.paper}`]: {
          bgcolor: "var(--layout-nav-bg)",
          overflow: "unset",
          pt: 2.5,
          px: 2.5,
          width: "var(--layout-nav-mobile-width)",
          ...sxSidebar,
        },
      }}
    >
      <NavigationContent onNavigationItemSelected={onClose} slots={slots} />
    </Drawer>
  );
};
